export default class ContentToc {
    constructor(query) {
        this.el = document.querySelector(query);
        if (!this.el) return;

        this.content = this.el.querySelector('[data-content-toc-body]');
        this.toc = this.el.querySelector('[data-content-toc]');
        this.offset = 96;

        if (!this.content || !this.toc) return;

        this.init();
    }

    init() {
        const headings = this.content.querySelectorAll('h2, h3, h4');

        headings.forEach((heading, index) => {
            const id = heading.id || `content-section-${index + 1}`;

            heading.id = id;

            const link = document.createElement('a');

            link.className = 'content-toc__toc-link';
            link.href = `#${id}`;

            link.innerHTML = `
                <span class="content-toc__toc-text">${heading.textContent}</span>
            `;

            link.addEventListener('click', (event) => {
                event.preventDefault();

                this.scrollToHeading(heading);
            });

            this.toc.append(link);
        });
    }

    scrollToHeading(heading) {
        const top =
            heading.getBoundingClientRect().top +
            window.pageYOffset -
            this.offset;

        window.scrollTo({
            top,
            behavior: 'smooth',
        });
    }
}